import { useQuery } from '@tanstack/react-query';

import { Endpoints } from '@xver/apis';
import { Charge } from '@xver/@types/charge';

export const CHARGE_STATUS_QUERY_KEY = 'apis.v1.charges.status';

export function useChargeStatusQuery(sourceID: string | undefined, enabled: boolean) {
    return useQuery<Charge>({
        queryKey: [CHARGE_STATUS_QUERY_KEY, sourceID],
        queryFn: () => Endpoints.v1.Charges.getChargeInfo(sourceID as string),
        enabled: Boolean(sourceID) && enabled,
        refetchInterval: (query) => (query.state.data?.status === 'successful' ? false : 2500),
        refetchIntervalInBackground: false,
    });
}
